/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairCabinClass {
  ECONOMY = 'ECONOMY',
  ECOPREMIUM = 'ECOPREMIUM',
  BUSINESS = 'BUSINESS',
  FIRST = 'FIRST'
}

